"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageSourceFromMedia = exports.srcsetFromMedia = void 0;
const array_1 = require("../../common/js/helper/array");
const MimeTypes_1 = __importDefault(require("../enums/MimeTypes"));
const sortThumbnailsByWidth = (thumbnails) => thumbnails.sort((a, b) => a.width - b.width);
const srcsetFromMedia = (media) => {
    const { thumbnails = [], mimeType, url } = media;
    if (mimeType === MimeTypes_1.default.svg) {
        return `${url} 0w`;
    }
    return sortThumbnailsByWidth([...thumbnails])
        .map((thumbnail) => `${thumbnail.url} ${thumbnail.width}w`)
        .join(', ');
};
exports.srcsetFromMedia = srcsetFromMedia;
const imageSourceFromMedia = (media) => {
    const { thumbnails = [], mimeType, url } = media;
    if (mimeType === MimeTypes_1.default.svg) {
        return {
            src: url,
        };
    }
    const smallestImage = (0, array_1.first)(sortThumbnailsByWidth([...thumbnails]));
    return {
        src: smallestImage?.url ?? url,
        srcSet: (0, exports.srcsetFromMedia)(media),
    };
};
exports.imageSourceFromMedia = imageSourceFromMedia;
